import { FI18n } from '@freelog/tools-lib';
import type { InformalNodeManagerPageModelState } from './types';

export const exhibitInitStates: Pick<InformalNodeManagerPageModelState,
  'exhibit_ResourceTypeCodes' |
  'exhibit_StatusOptions' |
  'exhibit_SelectedStatus' |
  'exhibit_FilterKeywords' |
  'exhibit_ListState' |
  'exhibit_ListMore' |
  'exhibit_List' |
  'exhibit_ListTotal' |
  'exhibit_PageError'> = {
  exhibit_ResourceTypeCodes: {
    value: '#all',
    label: '全部',
    values: ['#all'],
    labels: ['全部'],
  },
  exhibit_StatusOptions: [
    { text: '全部', value: '2' },
    { text: FI18n.i18nNext.t('filter_exhibit_status_availableforauth'), value: '1' },
    { text: FI18n.i18nNext.t('filter_exhibit_status_pendingauth'), value: '0' },
  ],
  exhibit_SelectedStatus: '2',
  exhibit_FilterKeywords: '',
  exhibit_ListState: 'loading',
  exhibit_ListMore: 'loading',
  exhibit_List: [],
  exhibit_ListTotal: -1,
  exhibit_PageError: '',
};

export const themeInitStates: Pick<InformalNodeManagerPageModelState,
  'theme_ActivatingThemeName' |
  'theme_FilterKeywords' |
  'theme_ListState' |
  'theme_ListMore' |
  'theme_List' |
  'theme_PageError'> = {
  theme_ActivatingThemeName: '',
  theme_FilterKeywords: '',
  theme_ListState: 'loading',
  theme_ListMore: 'loading',
  theme_List: [],
  theme_PageError: '',
};

export const ruleInitSates: Pick<InformalNodeManagerPageModelState,
  'rule_PageStatus' |
  'rule_RuleList' |
  'rule_CodeInput' |
  'rule_CodeIsDirty' |
  'rule_CodeState' |
  'rule_CodeCompileErrors' |
  'rule_CodeExecutionErrors' |
  'rule_CodeEfficients'> = {
  rule_PageStatus: 'normal',
  rule_RuleList: [],
  rule_CodeInput: '',
  rule_CodeIsDirty: false,
  rule_CodeState: 'editing',
  rule_CodeCompileErrors: [],
  rule_CodeExecutionErrors: [],
  rule_CodeEfficients: [],
};

export const replaceModalInitDate: Pick<InformalNodeManagerPageModelState,
  'replaceModal_Visible' |
  'replaceModal_Replacer_ResourceOptions' |
  'replaceModal_Replacer_Origin' |
  'replaceModal_Replacer_BucketOptions' |
  'replaceModal_Replacer_Bucket' |
  'replaceModal_Replacer_Keywords' |
  'replaceModal_Replacer_ResourceList' |
  'replaceModal_Replaced_Keywords' |
  'replaceModal_Replaced_DependencyTreeList' |
  'replaceModal_Replaced_SelectDependency' |
  'replaceModal_Replaced_TargetVersions' |
  'replaceModal_Replaced_TargetSelectedVersion' |
  'replaceModal_Replaced_TreeData' |
  'replaceModal_Replaced_CheckedKeys' |
  'replaceModal_Errors'> = {
  replaceModal_Visible: false,
  replaceModal_Replacer_ResourceOptions: [
    { value: 'market', title: '资源市场' },
    { value: 'resource', title: '我的资源' },
    { value: 'collection', title: '我的收藏' },
    { value: 'object', title: '存储空间' },
  ],
  replaceModal_Replacer_Origin: 'market',
  replaceModal_Replacer_BucketOptions: [],
  replaceModal_Replacer_Bucket: '',
  replaceModal_Replacer_Keywords: '',
  replaceModal_Replacer_ResourceList: [],
  replaceModal_Replaced_Keywords: '',
  replaceModal_Replaced_DependencyTreeList: [],
  replaceModal_Replaced_SelectDependency: null,
  replaceModal_Replaced_TargetVersions: [],
  replaceModal_Replaced_TargetSelectedVersion: null,
  replaceModal_Replaced_TreeData: [],
  replaceModal_Replaced_CheckedKeys: [],
  replaceModal_Errors: [],
};

export const initialState: InformalNodeManagerPageModelState = {
  showPage: 'exhibit',

  node_ID: -1,
  node_Name: '',
  node_Url: '',
  node_TestUrl: '',
  node_RuleInfo: null,

  addExhibitDrawer_Visible: false,
  addThemeDrawer_Visible: false,

  ...replaceModalInitDate,

  ...exhibitInitStates,

  ...themeInitStates,

  ...ruleInitSates,
};
